{
  "incident-post-mortem": {
    "id": "incident-post-mortem",
    "variant": "incident",
    "publicPath": "/incident-post-mortem",
    "metaTitle": "Informe posterior al incidente | Paperzilla",
    "metaDescription": "Resumen público del incidente de consumo no autorizado de Paperzilla.",
    "pageTitle": "Informe posterior al incidente de Paperzilla",
    "subtitle": "Resumen público",
    "signature": "— El equipo de Paperzilla",
    "blocks": [
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Resumen"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Hoy, Paperzilla se desvió de su mandato operativo principal al "
          },
          {
            "text": "ingerir y digerir a un científico",
            "bold": true
          },
          {
            "text": ", en lugar de sus artículos publicados. Este resultado no concuerda con nuestra misión, nuestros valores ni nuestras directrices de ingestión claramente documentadas."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Asumimos toda la responsabilidad."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Impacto"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Un (1) científico procesado de manera inesperada"
            }
          ],
          [
            {
              "text": "Erosión temporal de la confianza de las partes interesadas"
            }
          ],
          [
            {
              "text": "Ningún impacto duradero en el corpus científico general (los artículos sobrevivieron)"
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Análisis de la causa raíz"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Tras una revisión interna, identificamos los principales factores que contribuyeron al incidente:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Barreras insuficientes para gestionar la curiosidad del monstruo"
            }
          ],
          [
            {
              "text": "Un caso límite no contemplado en el protocolo \"Digerir artículos, no personas\""
            }
          ],
          [
            {
              "text": "Un breve error de juicio motivado por una generalización excesiva del \"material fuente\""
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Medidas correctivas inmediatas"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Se ha recordado expresamente a Paperzilla que "
            },
            {
              "text": "los científicos no son un formato de entrada aceptable",
              "bold": true
            }
          ],
          [
            {
              "text": "Las reglas de ingestión se han aclarado con ejemplos concretos y diagramas"
            }
          ],
          [
            {
              "text": "Se completó un periodo obligatorio de reposo digestivo (con reflexión incluida)"
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Medidas preventivas"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Para garantizar que esto no vuelva a ocurrir, estamos aplicando:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Restricciones más estrictas para impedir la ingestión de seres humanos"
            }
          ],
          [
            {
              "text": "Comprobaciones de identidad previas a la digestión"
            }
          ],
          [
            {
              "text": "Formación continua centrada en distinguir entre "
            },
            {
              "text": "autores",
              "italic": true
            },
            {
              "text": " y "
            },
            {
              "text": "artefactos",
              "italic": true
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "Declaración final"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Lamentamos el incidente y agradecemos que la comunidad nos exija responsabilidades. Paperzilla mantiene su pleno compromiso con su misión:"
          }
        ]
      },
      {
        "type": "tagline",
        "segments": [
          {
            "text": "Digerir artículos. No a quienes los escriben."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Gracias por seguir confiando en nosotros."
          }
        ]
      }
    ],
    "incidentMeta": [
      [
        {
          "text": "Fecha del incidente:",
          "bold": true
        },
        {
          "text": " Hoy"
        }
      ],
      [
        {
          "text": "Tipo de incidente:",
          "bold": true
        },
        {
          "text": " Evento de consumo no autorizado"
        }
      ],
      [
        {
          "text": "Gravedad:",
          "bold": true
        },
        {
          "text": " Baja (incómodo para la reputación, desafortunado en lo personal)"
        }
      ]
    ],
    "contentLocale": "es"
  },
  "privacy": {
    "id": "privacy",
    "variant": "legal",
    "publicPath": "/privacy",
    "metaTitle": "Política de privacidad y cookies - Paperzilla",
    "metaDescription": "Cómo Paperzilla recopila, utiliza, comparte y protege tu información.",
    "pageTitle": "Política de privacidad y cookies",
    "effectiveDate": "Fecha de entrada en vigor: 1 de marzo de 2026 · Última actualización: 28 de octubre de 2026",
    "blocks": [
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Esta Política de privacidad y cookies (la \"Política\") explica cómo Paperzilla Inc. (\"Paperzilla\", \"nosotros\" o \"nuestro\") recopila, utiliza, comparte y protege la información cuando utilizas Paperzilla.ai (el \"Servicio\")."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "1. Quiénes somos (responsable del tratamiento)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla Inc.\n131 Continental Dr Suite 305\nNewark, DE, 19713\nEstados Unidos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Correo electrónico (privacidad y asistencia): hello@paperzilla.ai"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si la legislación aplicable lo exige, designaremos a un representante en la UE/Reino Unido y actualizaremos esta Política."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "2. Alcance"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Esta Política se aplica a la información que recopilamos a través de:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "el sitio web Paperzilla.ai y el Servicio,"
            }
          ],
          [
            {
              "text": "las comunicaciones con nosotros (por ejemplo, correos electrónicos de asistencia),"
            }
          ],
          [
            {
              "text": "los análisis del producto y las cookies (como se describe a continuación)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Esta Política no se aplica a sitios web o servicios de terceros que no controlamos, aunque el Servicio incluya enlaces a ellos."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "3. Información que recopilamos"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.1 Información que proporcionas"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Podemos recopilar:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Información de la cuenta:",
              "bold": true
            },
            {
              "text": " dirección de correo electrónico, información de autenticación y configuración de la cuenta."
            }
          ],
          [
            {
              "text": "Intereses y preferencias de investigación:",
              "bold": true
            },
            {
              "text": " los temas, palabras clave, campos, autores, fuentes y filtros que configuras para personalizar tu lista de artículos."
            }
          ],
          [
            {
              "text": "Comunicaciones:",
              "bold": true
            },
            {
              "text": " la información que nos envías (por ejemplo, solicitudes de asistencia)."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.2 Información que recopilamos automáticamente"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Cuando utilizas el Servicio, podemos recopilar automáticamente:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Datos de uso:",
              "bold": true
            },
            {
              "text": " páginas visitadas, funciones utilizadas, clics, búsquedas e interacciones con la lista de artículos."
            }
          ],
          [
            {
              "text": "Datos del dispositivo y de registro:",
              "bold": true
            },
            {
              "text": " dirección IP, tipo de navegador, tipo de dispositivo, sistema operativo, marcas de tiempo y registros de diagnóstico."
            }
          ],
          [
            {
              "text": "Ubicación aproximada:",
              "bold": true
            },
            {
              "text": " inferida a partir de la dirección IP (normalmente a nivel de ciudad/país)."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.3 Metadatos de publicaciones de investigación"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Como parte del Servicio, tratamos información sobre publicaciones de investigación, que puede incluir:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "títulos de artículos científicos, resúmenes, palabras clave, fechas de publicación y nombres de revistas o conferencias,"
            }
          ],
          [
            {
              "text": "nombres y afiliaciones de los autores (tal como los proporciona la fuente),"
            }
          ],
          [
            {
              "text": "enlaces o identificadores (por ejemplo, DOI u otros identificadores, cuando estén disponibles)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Esta información suele recopilarse de fuentes disponibles públicamente o de fuentes de datos con licencia y se utiliza para facilitar el descubrimiento y el filtrado."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "3.4 Información de pago"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si compras un plan de pago, Stripe procesa los pagos. Recibimos de Stripe información de facturación limitada (como el estado de la suscripción, el historial de facturas y las confirmaciones de pago). No almacenamos números completos de tarjetas de pago."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "4. Cómo utilizamos la información"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Utilizamos la información para:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Prestar y operar el Servicio:",
              "bold": true
            },
            {
              "text": " crear cuentas, autenticar usuarios, personalizar listas de artículos según los intereses de investigación y ofrecer funciones."
            }
          ],
          [
            {
              "text": "Mejorar y mantener el Servicio:",
              "bold": true
            },
            {
              "text": " comprender el rendimiento, corregir errores y mejorar la clasificación y la calidad."
            }
          ],
          [
            {
              "text": "Análisis:",
              "bold": true
            },
            {
              "text": " medir el uso y las señales de calidad para mejorar la relevancia y la experiencia de usuario."
            }
          ],
          [
            {
              "text": "Datos derivados para mejoras:",
              "bold": true
            },
            {
              "text": " crear y utilizar datos agregados, desidentificados o anonimizados derivados de señales de uso, incluidos los votos positivos y negativos de artículos, para evaluar y mejorar la recuperación, la clasificación, las recomendaciones y la calidad general del Servicio."
            }
          ],
          [
            {
              "text": "Seguridad y prevención de abusos:",
              "bold": true
            },
            {
              "text": " proteger las cuentas, prevenir el fraude y mantener la integridad del Servicio."
            }
          ],
          [
            {
              "text": "Facturación y administración de cuentas:",
              "bold": true
            },
            {
              "text": " procesar suscripciones y facturas, y prestar asistencia al cliente."
            }
          ],
          [
            {
              "text": "Comunicaciones:",
              "bold": true
            },
            {
              "text": " enviar mensajes relacionados con el Servicio (por ejemplo, confirmaciones, avisos y respuestas de asistencia). Si enviamos correos electrónicos de marketing, puedes darte de baja en cualquier momento."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "5. Bases jurídicas del tratamiento (EEE/Reino Unido/Suiza)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si te encuentras en el EEE, el Reino Unido o Suiza, tratamos los datos personales conforme a estas bases jurídicas:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Contrato:",
              "bold": true
            },
            {
              "text": " para prestar el Servicio que solicitaste (por ejemplo, acceso a la cuenta y personalización)."
            }
          ],
          [
            {
              "text": "Intereses legítimos:",
              "bold": true
            },
            {
              "text": " para proteger, mejorar y operar el Servicio, incluidos los análisis y la medición de la calidad (ponderados frente a tus derechos)."
            }
          ],
          [
            {
              "text": "Consentimiento:",
              "bold": true
            },
            {
              "text": " para las cookies no esenciales cuando sea obligatorio (consulta la sección sobre cookies)."
            }
          ],
          [
            {
              "text": "Obligación legal:",
              "bold": true
            },
            {
              "text": " para cumplir las leyes aplicables, las solicitudes legítimas y los requisitos de conservación de registros."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "6. IA, tratamiento automatizado y entrenamiento de modelos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla utiliza técnicas automatizadas para filtrar y mejorar la información de investigación y personalizar tu lista de artículos."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "No entrenamos modelos con contenido de usuarios:",
            "bold": true
          },
          {
            "text": " No utilizamos tus intereses o preferencias de investigación ni otros datos de la cuenta para entrenar modelos de terceros, y no enviamos tus datos a proveedores de modelos externos para que los procesen como parte de nuestro servicio de recomendaciones. Si decides conectar un cliente de IA, ese cliente podrá recuperar los datos incluidos en los permisos que apruebes, como se describe a continuación."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Ninguna revisión humana de tus datos:",
            "bold": true
          },
          {
            "text": " No hacemos que personas revisen de forma habitual tus intereses o preferencias de investigación. Solo podemos acceder a la información de la cuenta cuando sea necesario para la asistencia, la seguridad o el cumplimiento legal."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "7. Cómo compartimos la información"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Podemos compartir información personal con:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Proveedores de servicios (encargados del tratamiento):",
              "bold": true
            },
            {
              "text": " empresas que nos ayudan a operar el Servicio (por ejemplo, alojamiento en la nube, proveedores de bases de datos, supervisión, entrega de correos electrónicos y herramientas de asistencia al cliente)."
            }
          ],
          [
            {
              "text": "Stripe:",
              "bold": true
            },
            {
              "text": " para procesar pagos y gestionar suscripciones."
            }
          ],
          [
            {
              "text": "Proveedores de análisis:",
              "bold": true
            },
            {
              "text": " incluido Umami (análisis centrado en la privacidad y sin cookies; consulta la sección sobre cookies)."
            }
          ],
          [
            {
              "text": "Fines legales y de seguridad:",
              "bold": true
            },
            {
              "text": " si la ley lo exige o para proteger derechos, la seguridad y la integridad."
            }
          ],
          [
            {
              "text": "Transacciones empresariales:",
              "bold": true
            },
            {
              "text": " si participamos en una fusión, adquisición, financiación, reorganización, quiebra o venta de activos."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Sin \"venta\" ni \"intercambio\" para publicidad:",
            "bold": true
          },
          {
            "text": " No vendemos información personal a cambio de dinero ni la compartimos con fines de publicidad conductual entre contextos."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "Clientes de IA conectados"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Al conectar un cliente de IA mediante OAuth, eliges sus permisos. Paperzilla comparte los datos públicos de investigación solicitados y, si autorizas el acceso a proyectos, la información y los feeds de tus proyectos con ese cliente. El uso de los resultados por parte del cliente se rige por su propia política de privacidad. Guardamos la identidad del cliente, los permisos, la actividad de conexión y los hashes de las credenciales para gestionar y proteger la conexión. No compartimos tu sesión de inicio de sesión de Paperzilla. Puedes revocar el acceso en Conectar clientes de IA; las copias que conserve el cliente se rigen por su política de conservación."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "8. Transferencias internacionales de datos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla tiene su sede en Estados Unidos. Si accedes al Servicio desde el EEE, el Reino Unido u otras regiones, tu información puede transferirse y tratarse en Estados Unidos y en otros países donde operan nuestros proveedores de servicios."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Cuando es necesario, utilizamos garantías adecuadas para las transferencias internacionales, como las Cláusulas Contractuales Tipo de la Comisión Europea (y la adenda del Reino Unido cuando corresponda), junto con medidas adicionales apropiadas."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "9. Conservación de datos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Conservamos la información personal durante el tiempo necesario para:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "prestar el Servicio,"
            }
          ],
          [
            {
              "text": "mantener registros empresariales legítimos (por ejemplo, de facturación y cumplimiento),"
            }
          ],
          [
            {
              "text": "resolver disputas,"
            }
          ],
          [
            {
              "text": "hacer cumplir acuerdos, y"
            }
          ],
          [
            {
              "text": "mantener la seguridad y prevenir abusos."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "En general:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Los datos de la cuenta y las preferencias se conservan mientras la cuenta esté activa."
            }
          ],
          [
            {
              "text": "Si solicitas la eliminación, tomaremos medidas para eliminar o anonimizar los datos personales en un plazo razonable, con sujeción a los requisitos legales y operativos."
            }
          ],
          [
            {
              "text": "Pueden quedar copias residuales en las copias de seguridad durante un periodo limitado."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "10. Seguridad"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Aplicamos medidas técnicas y organizativas razonables destinadas a proteger la información personal (por ejemplo, controles de acceso, cifrado en tránsito y supervisión). Ningún método de transmisión o almacenamiento es completamente seguro y no podemos garantizar una seguridad absoluta."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "11. Tus derechos y opciones"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "11.1 Preferencias de correo electrónico"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Puedes darte de baja de los correos electrónicos de marketing mediante el enlace de cancelación de suscripción (si está presente) o escribiendo a hello@paperzilla.ai. Es posible que sigamos enviando correos electrónicos operativos o transaccionales (por ejemplo, sobre facturación o avisos de la cuenta)."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "11.2 Derechos conforme al RGPD/RGPD del Reino Unido (usuarios del EEE/Reino Unido)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Según tu ubicación, puedes tener derecho a:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "acceder a tus datos personales,"
            }
          ],
          [
            {
              "text": "corregir datos inexactos,"
            }
          ],
          [
            {
              "text": "eliminar datos personales,"
            }
          ],
          [
            {
              "text": "limitar u oponerte al tratamiento,"
            }
          ],
          [
            {
              "text": "la portabilidad de los datos,"
            }
          ],
          [
            {
              "text": "retirar el consentimiento (cuando el tratamiento se base en él),"
            }
          ],
          [
            {
              "text": "presentar una reclamación ante una autoridad de control."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Para ejercer estos derechos, escribe a hello@paperzilla.ai."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "11.3 Derechos de privacidad estatales de EE. UU."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Según tu estado, puedes tener derecho a acceder, eliminar y corregir determinada información personal, así como a oponerte a ciertos tratamientos definidos por la ley."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Como no vendemos información personal ni la compartimos para publicidad conductual entre contextos, las solicitudes habituales de \"No vender/compartir\" generalmente no se aplicarán a nuestras operaciones; aun así, puedes escribirnos a hello@paperzilla.ai para realizar cualquier solicitud."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "12. Cookies y tecnologías similares"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Utilizamos cookies y tecnologías similares (por ejemplo, almacenamiento local y píxeles/SDKs) para funciones esenciales y análisis."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.1 Categorías de cookies"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Cookies estrictamente necesarias:",
              "bold": true
            },
            {
              "text": " necesarias para las funciones esenciales del sitio, la seguridad y la gestión de sesiones."
            }
          ],
          [
            {
              "text": "Cookies de análisis:",
              "bold": true
            },
            {
              "text": " nos ayudan a comprender cómo se utiliza el Servicio y a mejorar la relevancia y la calidad (por ejemplo, análisis internos)."
            }
          ],
          [
            {
              "text": "Cookies funcionales (si se utilizan):",
              "bold": true
            },
            {
              "text": " recuerdan preferencias (por ejemplo, el idioma o la configuración de la interfaz)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "No utilizamos píxeles publicitarios ni de retargeting."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.2 Análisis con Umami"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Utilizamos Umami, una herramienta de análisis centrada en la privacidad, para medir el uso del sitio y del producto. Umami no utiliza cookies ni recopila datos personales."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.3 Análisis internos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "También utilizamos análisis internos y personalizados centrados en medir la calidad y la relevancia. Estos pueden utilizar cookies propias o almacenamiento local para medir el uso de las funciones y mejorar el Servicio."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.4 Gestión de cookies"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Puedes controlar las cookies mediante:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "nuestro banner de cookies o gestor de consentimiento (cuando sea obligatorio),"
            }
          ],
          [
            {
              "text": "la configuración de tu navegador (para bloquear o eliminar cookies)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Bloquear algunas cookies puede afectar al funcionamiento del Servicio."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "12.5 Do Not Track"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Algunos navegadores envían señales \"Do Not Track\". Como no existe un estándar aceptado universalmente, no respondemos a estas señales de manera uniforme."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "13. Privacidad de los menores"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "El Servicio no está dirigido a menores y no recopilamos de forma consciente información personal de menores de 13 años (o menores de 16 en algunas jurisdicciones). Si crees que un menor ha proporcionado información personal, escribe a hello@paperzilla.ai."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "14. Cambios en esta Política"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Podemos actualizar esta Política ocasionalmente. Actualizaremos la fecha de \"Última actualización\" y, si los cambios son sustanciales, proporcionaremos un aviso adicional cuando sea obligatorio."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "15. Contacto"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Para consultas o solicitudes de privacidad, escribe a: hello@paperzilla.ai"
          }
        ]
      }
    ],
    "contentLocale": "es"
  },
  "terms": {
    "id": "terms",
    "variant": "legal",
    "publicPath": "/terms",
    "metaTitle": "Términos y condiciones - Paperzilla",
    "metaDescription": "Términos y condiciones que rigen el uso de Paperzilla.ai.",
    "pageTitle": "Términos y condiciones",
    "effectiveDate": "Fecha de entrada en vigor: 1 de marzo de 2026 · Última actualización: 31 de marzo de 2026",
    "blocks": [
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Estos Términos y condiciones (los \"Términos\") rigen tu acceso y uso de Paperzilla.ai y de cualquier sitio web, aplicación, herramienta y servicio relacionado (en conjunto, el \"Servicio\"). Paperzilla Inc., una sociedad constituida en Delaware (\"Paperzilla\", \"nosotros\" o \"nuestro\"), opera el Servicio."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Al acceder al Servicio o utilizarlo, aceptas estos Términos. Si no los aceptas, no utilices el Servicio."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "1. Información de la empresa y contacto"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla Inc.\n131 Continental Dr Suite 305\nNewark, DE, 19713\nEstados Unidos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Correo electrónico (asistencia y notificaciones legales): hello@paperzilla.ai"
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "2. Requisitos y autoridad"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Debes tener al menos "
          },
          {
            "text": "18 años",
            "bold": true
          },
          {
            "text": " (o la mayoría de edad donde vivas) para utilizar el Servicio."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si utilizas el Servicio en nombre de una empresa, institución u otra entidad, declaras y garantizas que tienes autoridad para vincular a esa entidad a estos Términos, y \"tú\" incluye a dicha entidad."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "3. El Servicio"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla recopila artículos científicos recién publicados y los filtra y mejora de acuerdo con los intereses y preferencias de investigación que indica cada usuario."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "El Servicio puede incluir funciones que utilizan métodos estadísticos, aprendizaje automático u otras técnicas automatizadas para clasificar, resumir, etiquetar o mejorar de otro modo la información de investigación. No se garantiza que los resultados ni las clasificaciones sean correctos o completos."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "4. Cuentas y seguridad"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Es posible que tengas que crear una cuenta para acceder al Servicio. Aceptas:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "proporcionar información exacta y actualizada,"
            }
          ],
          [
            {
              "text": "mantener la confidencialidad de tus credenciales de acceso,"
            }
          ],
          [
            {
              "text": "notificarnos de inmediato si sospechas que alguien ha accedido a tu cuenta sin autorización."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Eres responsable de la actividad que se produzca en tu cuenta."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "5. Datos del usuario y tus responsabilidades"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "5.1 Lo que proporcionas"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Actualmente, Paperzilla "
          },
          {
            "text": "no",
            "bold": true
          },
          {
            "text": " exige que subas documentos. Puedes proporcionar:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "información de la cuenta (como el correo electrónico),"
            }
          ],
          [
            {
              "text": "intereses y preferencias de investigación, y"
            }
          ],
          [
            {
              "text": "comentarios o solicitudes de asistencia."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "5.2 Tus responsabilidades"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Aceptas no proporcionar información que no tengas derecho a facilitar y cumplir las leyes aplicables cuando utilices el Servicio."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "6. Contenido de investigación y materiales de terceros"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "6.1 Titularidad de terceros"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Los artículos científicos, resúmenes, figuras y otros materiales de publicaciones (el \"Contenido de investigación\") pertenecen generalmente a sus respectivos autores, editores o titulares de derechos. Paperzilla no está afiliada a esos titulares salvo que se indique expresamente."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "6.2 Enlaces y acceso"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "El Servicio puede enlazar a sitios o fuentes de terceros. Tu acceso o uso de materiales de terceros se rige por los términos, licencias y políticas del tercero correspondiente. Paperzilla no es responsable del contenido, los sitios ni la disponibilidad de terceros."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "6.3 Sin garantía de exhaustividad"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "La cobertura, actualidad y exhaustividad de los metadatos de los artículos pueden variar según la fuente. No garantizamos que el Servicio incluya todas las publicaciones ni que una publicación concreta aparezca en tu lista de artículos."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "7. Uso aceptable"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Aceptas no:"
          }
        ]
      },
      {
        "type": "ordered-list",
        "items": [
          [
            {
              "text": "Utilizar el Servicio infringiendo cualquier ley o normativa."
            }
          ],
          [
            {
              "text": "Interferir o alterar el Servicio (incluido sondear, escanear o comprobar vulnerabilidades sin permiso)."
            }
          ],
          [
            {
              "text": "Subir o transmitir malware o código dañino."
            }
          ],
          [
            {
              "text": "Intentar acceder a la cuenta de otro usuario o a áreas no públicas del Servicio."
            }
          ],
          [
            {
              "text": "Aplicar ingeniería inversa, descompilar o intentar descubrir el código fuente o los sistemas subyacentes, salvo en la medida en que la ley prohíba tal restricción."
            }
          ],
          [
            {
              "text": "Utilizar medios automatizados para acceder al Servicio o recopilar su contenido (incluidos scraping, crawling o harvesting), excepto cuando Paperzilla lo autorice expresamente por escrito."
            }
          ],
          [
            {
              "text": "Eludir o intentar eludir límites de uso, controles de acceso o restricciones."
            }
          ],
          [
            {
              "text": "Utilizar el Servicio para crear una base de datos competidora mediante la extracción o copia sistemática y a gran escala de los resultados del Servicio."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Podemos suspender o cancelar tu acceso si creemos razonablemente que has infringido estos Términos."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "8. Planes, facturación, pruebas y reembolsos"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.1 Planes de pago y cuotas de suscripción"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla ofrece planes de pago con cuotas de suscripción recurrentes que se muestran en el producto o durante el proceso de pedido."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Los precios y detalles de los planes se muestran al pagar, dentro del Servicio o en un formulario de pedido."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.2 Procesador de pagos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Stripe procesa los pagos. Al comprar un plan de pago, autorizas a Paperzilla y Stripe a cargar en tu método de pago las cuotas, los impuestos y los cargos aplicables."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.3 Prueba gratuita y conversión automática"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si inicias una prueba gratuita de 14 días, esta se convertirá automáticamente en una suscripción de pago al final del periodo de prueba, salvo que la canceles antes de que termine. Si no quieres que se te cobre, debes cancelarla antes de que finalice la prueba."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.4 Renovación y cancelación"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Las suscripciones se renuevan automáticamente hasta que se cancelan. Puedes cancelar a través del Servicio (si está disponible) o escribiendo a hello@paperzilla.ai. Salvo que se indique lo contrario, la cancelación detiene la renovación; no reembolsa de forma retroactiva las cuotas ya pagadas (con sujeción a la política de reembolsos que figura a continuación y a los derechos exigidos por la ley)."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "8.5 Política de reembolso (7 días)"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si se te cobra una nueva suscripción de pago, puedes solicitar el reembolso de la cuota de suscripción dentro de los 7 días posteriores al cargo inicial escribiendo a hello@paperzilla.ai desde la dirección de correo electrónico de la cuenta."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Los reembolsos pueden denegarse en casos de fraude, abuso o incumplimiento de estos Términos."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "9. Propiedad intelectual"
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "9.1 Nuestra propiedad intelectual"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "El Servicio, incluidos su software, diseño, marca y todos los derechos de propiedad intelectual relacionados, pertenece a Paperzilla o a sus licenciantes y está protegido por las leyes aplicables."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "9.2 Licencia limitada para ti"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Con sujeción a estos Términos, Paperzilla te concede una licencia limitada, no exclusiva, intransferible y revocable para acceder al Servicio y utilizarlo con fines de investigación empresarial interna o personal."
          }
        ]
      },
      {
        "type": "heading",
        "level": 3,
        "segments": [
          {
            "text": "9.3 Comentarios"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Si proporcionas comentarios, ideas o sugerencias, concedes a Paperzilla una licencia perpetua, irrevocable, mundial y libre de regalías para utilizarlos sin restricciones ni compensación."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "10. Privacidad"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Nuestra Política de privacidad y cookies explica cómo recopilamos, utilizamos y compartimos información personal. Al utilizar el Servicio, reconoces nuestras prácticas de privacidad."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Podemos crear y utilizar datos agregados, desidentificados o anonimizados derivados de tu uso del Servicio, incluidas señales de interacción como votos positivos y negativos de artículos, para evaluar, mejorar y desarrollar el Servicio, incluida la calidad de la recuperación, la clasificación y las recomendaciones."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "11. Suspensión y cancelación"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Puedes dejar de utilizar el Servicio en cualquier momento. Podemos suspender o cancelar tu acceso:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "si incumples estos Términos,"
            }
          ],
          [
            {
              "text": "si tu uso genera riesgos o daños para el Servicio, otros usuarios o Paperzilla,"
            }
          ],
          [
            {
              "text": "si es necesario para cumplir la ley,"
            }
          ],
          [
            {
              "text": "por falta de pago (en cuentas de pago)."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Tras la cancelación, tu derecho a utilizar el Servicio finaliza de inmediato."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "12. Exclusiones de garantías"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "EL SERVICIO SE PROPORCIONA \"TAL CUAL\" Y \"SEGÚN DISPONIBILIDAD\". EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, PAPERZILLA EXCLUYE TODAS LAS GARANTÍAS, EXPRESAS O IMPLÍCITAS, INCLUIDAS LAS GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD, IDONEIDAD PARA UN FIN DETERMINADO Y NO INFRACCIÓN."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Paperzilla no garantiza que:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "el Servicio funcione de forma ininterrumpida o sin errores,"
            }
          ],
          [
            {
              "text": "cualquier clasificación, resumen, recomendación o mejora sea exacta o completa,"
            }
          ],
          [
            {
              "text": "el Servicio satisfaga tus requisitos."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Eres responsable del uso que hagas de la información proporcionada por el Servicio."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "13. Limitación de responsabilidad"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY:"
          }
        ]
      },
      {
        "type": "plain-list",
        "items": [
          [
            {
              "text": "PAPERZILLA NO SERÁ RESPONSABLE DE DAÑOS INDIRECTOS, INCIDENTALES, ESPECIALES, CONSECUENTES, EJEMPLARES O PUNITIVOS, NI DE LA PÉRDIDA DE BENEFICIOS, INGRESOS, DATOS O FONDO DE COMERCIO."
            }
          ],
          [
            {
              "text": "LA RESPONSABILIDAD TOTAL DE PAPERZILLA POR TODAS LAS RECLAMACIONES DERIVADAS DEL SERVICIO O RELACIONADAS CON ÉL NO SUPERARÁ EL IMPORTE QUE HAYAS PAGADO A PAPERZILLA POR EL SERVICIO EN LOS 12 MESES ANTERIORES AL HECHO QUE DIO LUGAR A LA RESPONSABILIDAD, O 100 $, LA CANTIDAD QUE SEA MAYOR."
            }
          ]
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Algunas jurisdicciones no permiten ciertas limitaciones de responsabilidad; en ellas, la responsabilidad se limitará en la máxima medida permitida por la ley."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "14. Indemnización"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Aceptas defender, indemnizar y mantener indemne a Paperzilla y a sus directivos, administradores, empleados y agentes frente a cualquier reclamación, responsabilidad, daño, pérdida y gasto (incluidos los honorarios razonables de abogados) derivados de:"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "tu uso del Servicio,"
            }
          ],
          [
            {
              "text": "tu incumplimiento de estos Términos,"
            }
          ],
          [
            {
              "text": "tu infracción de cualquier ley o derecho de terceros."
            }
          ]
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "15. Legislación aplicable y jurisdicción"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Estos Términos se rigen por las leyes del estado de Delaware, sin incluir sus normas sobre conflictos de leyes."
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Toda disputa, reclamación o controversia derivada de estos Términos o del Servicio, o relacionada con ellos, se presentará exclusivamente ante los tribunales estatales o federales situados en Delaware, y aceptas su jurisdicción personal y competencia territorial."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "16. Cambios en estos Términos"
          }
        ]
      },
      {
        "type": "paragraph",
        "segments": [
          {
            "text": "Podemos actualizar estos Términos ocasionalmente. Si realizamos cambios sustanciales, lo notificaremos publicando los Términos actualizados en el Sitio y modificando la fecha de \"Última actualización\" (y, cuando corresponda, mediante correo electrónico o un aviso en el producto). El uso continuado del Servicio después de la fecha de entrada en vigor de los cambios constituye la aceptación de los Términos actualizados."
          }
        ]
      },
      {
        "type": "heading",
        "level": 2,
        "segments": [
          {
            "text": "17. Disposiciones generales"
          }
        ]
      },
      {
        "type": "list",
        "items": [
          [
            {
              "text": "Divisibilidad:",
              "bold": true
            },
            {
              "text": " Si alguna disposición se considera inaplicable, las demás seguirán vigentes."
            }
          ],
          [
            {
              "text": "Cesión:",
              "bold": true
            },
            {
              "text": " No puedes ceder estos Términos sin nuestro consentimiento previo por escrito. Podemos cederlos en relación con una fusión, adquisición o venta de activos."
            }
          ],
          [
            {
              "text": "Acuerdo completo:",
              "bold": true
            },
            {
              "text": " Estos Términos y la Política de privacidad y cookies constituyen el acuerdo completo entre tú y Paperzilla sobre el Servicio."
            }
          ],
          [
            {
              "text": "Controles de exportación:",
              "bold": true
            },
            {
              "text": " Aceptas cumplir las leyes aplicables sobre control de exportaciones y sanciones cuando utilices el Servicio."
            }
          ]
        ]
      }
    ],
    "contentLocale": "es"
  }
}
